<mat-form-field appearance="outline">
  <mat-label>Curso</mat-label>
  <mat-select #cursoSelect [value]="selectedCursos$ | async" (selectionChange)="doSelected($event)" multiple>
    <mat-option #cursoTodos [value]="0" class="tools-hide-checkbox">
      Todos
    </mat-option>
    <mat-option *ngIf="includeCursosN" #cursoNuevos [value]="-1">
      Nuevos
    </mat-option>
    <ng-container *ngFor="let curso of (cursos$ | async) | filtroNuevo: false: includeSinHijos: parentOnly: parentSelect; trackBy curso">
      <mat-option [value]="curso.id">
        {{ curso.nombre }}
      </mat-option>
    </ng-container>
  </mat-select>
</mat-form-field>
